import { createFileRoute } from '@tanstack/react-router';
import UserLayout from '@components/layout/UserLayout.tsx';
import AddressPage from '@features/address/AddressPage.tsx';

export const Route = createFileRoute('/c/$orgId/$portalId/addresses')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <UserLayout>
      <>
        <AddressPage />
      </>
    </UserLayout>
  );
}
